import Vue from 'vue'
import { HTTP } from '../../../../utils/httpCommonUtil'
// import 'vue-loaders/dist/vue-loaders.css';
import { BallPulseLoader } from 'vue-loaders';

export default Vue.component('server-access-card', {
  name: 'ServerAccessCard',
  data () {
    let color: any
    return {
      color: color,
      colorIdErrorMessage: '',
      loadingColorData: false
    }
  },
  components: {
    BallPulseLoader
  },
  created: function () {
    this.color = { id: 6, name: '' }
  },
  methods: {
    cancel (param: string) {
      console.log('canceling.')
      this.color = {}
    },
    getColor (colorId: number) {
      let self = this
      self.colorIdErrorMessage = ''
      let loadingButtonTimeout = setTimeout(function () {
        self.loadingColorData = true;
      }, 500);
      HTTP.get('/api/colors/' + colorId)
      .then(function (response) {
        clearTimeout(loadingButtonTimeout);
        self.loadingColorData = false;
        self.color = response.data.data;
        self.$notify({
          group: 'main',
          type: 'success',
          title: 'Important message',
          text: 'Hello user! This is a notification!',
          // duration: -1
        });
      })
      .catch(function (error) {
        clearTimeout(loadingButtonTimeout);
        self.loadingColorData = false;
        self.colorIdErrorMessage = Boolean(error.response.data.errors.colorId.msg) ? error.response.data.errors.colorId.msg : ''
        self.$notify({
          group: 'main',
          type: 'error',
          title: 'Important message',
          text: 'Hello user! This is a notification!'
        });
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/serverAccess/ServerAccessCard.ts